import HeroImg from '../assets/HERO.jpg';
import resume from '../assets/ATCHAYA_Software_developer.pdf';
import { FaDownload, FaGraduationCap, FaTrophy } from 'react-icons/fa';

const stats = [
  { value: '2+', label: 'Years Experience' },
  { value: '5+', label: 'Live Projects' },
  { value: '8.66', label: 'CGPA' },
  { value: '10+', label: 'Technologies' },
];

const education = [
  {
    degree: 'B.E. Computer Science & Engineering',
    school: 'Sri Raaja Raajan College of Engineering and Technology, Karaikudi',
    period: 'Jul 2020 – May 2024',
    score: 'CGPA: 8.66 / 10.0',
    note: 'Top 2 rank out of 60 students',
  },
  {
    degree: 'HSC – Computer Science',
    school: 'Sri Ramana Vikas Higher Secondary School, Sivaganga',
    period: 'Mar 2020',
    score: '79%',
    note: '',
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-16 md:py-24 overflow-hidden">
      <div className="glow-orb w-72 h-72 bg-violet-600 -top-10 -right-20" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 scroll-animate">

          <h2 className="section-title gradient-text">About Me</h2>
          <div className="title-line" />
        </div>

        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16">
          {/* Image */}
          <div className="flex-shrink-0 scroll-animate-left">
            <div className="relative w-56 h-56 sm:w-64 sm:h-64 md:w-72 md:h-72 mx-auto">
              <div
                className="absolute inset-0 rounded-2xl"
                style={{ background: 'linear-gradient(135deg,#7c3aed,#06b6d4)', transform: 'rotate(6deg)', opacity: 0.3 }}
              />
              <div
                className="relative w-full h-full rounded-2xl overflow-hidden"
                style={{ border: '2px solid rgba(124,58,237,0.4)' }}
              >
                <img src={HeroImg} alt="Atchaya" className="w-full h-full object-cover object-top" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 scroll-animate-right w-full">
            <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 text-center md:text-left">
              Full Stack Developer | Immediate Joiner · Chennai
            </h3>
            <p className="text-slate-400 leading-relaxed mb-3 text-sm sm:text-base text-center md:text-left">
              Full Stack Developer with 2 years of experience building scalable web and mobile applications.
              Shipped 5+ production apps used by 200+ end users across ERP, HRMS, E-Commerce, and Safety domains —
              reducing client operational effort by up to 30%.

            </p>
            <p className="text-slate-400 leading-relaxed mb-6 text-sm sm:text-base text-center md:text-left">
              Skilled in ReactJS, React Native, ASP.NET Core, Node.js, Python, and SQL Server.
              I leverage AI tools to accelerate delivery and build clean, efficient, business-driven solutions.
            </p>

            {/* Education */}
            <div className="space-y-3 mb-7">
              {education.map((edu, i) => (
                <div key={i} className="glass-card p-3 sm:p-4 flex items-start gap-3">
                  <FaGraduationCap className="text-violet-400 mt-1 flex-shrink-0" size={16} />
                  <div>
                    <p className="text-white font-semibold text-sm">{edu.degree}</p>
                    <p className="text-slate-400 text-xs">{edu.school}</p>
                    <div className="flex flex-wrap gap-2 mt-1">
                      <span className="text-xs text-slate-500">{edu.period}</span>
                      <span className="text-xs text-violet-400 font-medium">{edu.score}</span>
                      {edu.note && (
                        <span className="flex items-center gap-1 text-xs text-amber-400">
                          <FaTrophy size={10} /> {edu.note}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex justify-center md:justify-start">
              <a href={resume} download="Atchaya_Resume" className="btn-primary inline-flex text-sm">
                <FaDownload size={13} /> Download Resume
              </a>
            </div>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-14 scroll-animate">
          {stats.map(s => (
            <div key={s.label} className="glass-card p-4 sm:p-6 text-center">
              <div className="text-3xl sm:text-4xl font-bold gradient-text mb-1">{s.value}</div>
              <div className="text-slate-400 text-xs sm:text-sm">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
